import { Box, type BoxProps, Typography, TypographyProps } from '@mui/material';
import type { FC, ReactNode } from 'react';
import React from 'react';

const Info: FC<{
  label: string;
  value: ReactNode;
  styles?: {
    box?: BoxProps['sx'];
    label?: TypographyProps['sx'];
    content?: TypographyProps['sx'];
  };
}> = ({ label, value, styles }) => {
  const isText = ['string', 'number'].includes(typeof value);
  return (
    <Box sx={styles?.box}>
      <Typography
        sx={{
          color: '#8B8B8B',
          fontSize: '0.9rem',
          mb: '0.25rem',
          ...styles?.label,
        }}
      >
        {label}
      </Typography>
      {isText && (
        <Typography
          sx={{
            fontWeight: 500,
            letterSpacing: '0.096rem',
            ...styles?.content,
          }}
        >
          {value}
        </Typography>
      )}
      {!isText && value}
    </Box>
  );
};

export default Info;
